export default {"src":"/_next/static/media/up-down-icon.26abc54f.svg","height":19,"width":14};